(function () {
  const overlays = document.querySelectorAll('.overlay');
  if (!overlays.length) return;

  document.querySelectorAll('.open-overlay').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = btn.dataset.overlayTarget || 'overlay-whitepaper';
      const overlay = document.getElementById(targetId);
      if (!overlay) return;

      const cf7Form = overlay.querySelector('.wpcf7-form');
      if (cf7Form && cf7Form.classList.contains('sent')) {
        cf7Form.classList.remove('sent', 'invalid', 'spam', 'failed');
        cf7Form.reset();
        const responseOutput = overlay.querySelector('.wpcf7-response-output');
        if (responseOutput) responseOutput.style.display = 'none';
      }

      overlay.classList.add('is-open');
    });
  });

  overlays.forEach(function (overlay) {
    const closeBtn = overlay.querySelector('.overlay__close');
    const backdrop = overlay.querySelector('.overlay__backdrop');

    if (closeBtn) closeBtn.addEventListener('click', function () {
      overlay.classList.remove('is-open');
    });

    if (backdrop) backdrop.addEventListener('click', function () {
      overlay.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      overlays.forEach(function (o) { o.classList.remove('is-open'); });
    }
  });
}());
